export function getEnvironmentByHost() {
  switch (true) {
    case window.location.hostname.includes('.tst.'): {
      return 'testing'
    }

    case window.location.hostname.includes('vendor.yandex.com'):
    case window.location.hostname.includes('vendor.yango.com'):
    case window.location.hostname.includes('vendor.yandex.ru'):
    case window.location.hostname.includes('vendor.eda.yandex'): {
      return 'production'
    }

    default: {
      return 'development'
    }
  }
}
